import { useState } from "react";
import { X } from "lucide-react";
import { api, ApiError } from "../../lib/api";
import { toast } from "../../stores/toast";

export function MyRaffleTickets({
  raffleId,
  tickets,
  onRemoved,
}: {
  raffleId: string;
  tickets: { ticketNo: number }[];
  onRemoved: () => void;
}) {
  const [busyNo, setBusyNo] = useState<number | null>(null);

  if (tickets.length === 0) return null;

  async function remove(ticketNo: number) {
    setBusyNo(ticketNo);
    try {
      await api(`/raffles/${raffleId}/withdraw-ticket`, { method: "POST", body: { ticketNo } });
      toast("success", `Ticket #${ticketNo} removed — you can enter again if slots remain`);
      onRemoved();
    } catch (err) {
      toast("error", err instanceof ApiError ? err.message : "Could not remove ticket");
    } finally {
      setBusyNo(null);
    }
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      {tickets.map((t) => (
        <button
          key={t.ticketNo}
          type="button"
          disabled={busyNo != null}
          onClick={() => void remove(t.ticketNo)}
          className="inline-flex items-center gap-1 rounded-lg bg-emerald-500/15 px-2 py-1 font-mono text-xs text-emerald-200 transition-colors hover:bg-emerald-500/25 disabled:opacity-50"
          title="Remove ticket before the draw"
        >
          #{t.ticketNo}
          <X className="h-3 w-3 opacity-70" aria-hidden />
        </button>
      ))}
    </div>
  );
}
